var _path, _g, _g2, _g3, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 31,
    viewBox: "0 0 35 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7446 3.8511L6.64378 6.64294C3.86734 7.73456 2.76639 10.418 3.90631 13.3173L6.53715 20.0086C7.67385 22.8997 10.3076 24.1147 13.084 23.0231L20.1848 20.2313C22.9612 19.1396 24.054 16.4594 22.9173 13.5683L20.2865 6.87705C19.1466 3.97776 16.521 2.75948 13.7446 3.8511Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5359 13.4569L19.7541 8.92012C19.1078 7.27453 17.6169 6.75417 15.707 7.50427L9.23871 10.0448C7.29759 10.8072 6.58436 12.1932 7.23068 13.8388L9.01253 18.3755C9.66927 20.0477 11.1245 20.5508 13.0656 19.7884L19.5339 17.2479C21.4438 16.4978 22.1927 15.129 21.5359 13.4569Z",
    fill: "#24348B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3974 11.5498L27.28 11.2918C26.963 10.6233 26.599 9.84928 26.3759 9.40362C25.8359 8.34812 24.9083 7.76173 23.7695 7.75H18.2395C17.1007 7.76173 16.1849 8.34812 15.6448 9.40362C15.41 9.87273 15.0108 10.7171 14.6821 11.4091L14.6116 11.5498C14.5764 11.6436 14.4825 11.6905 14.3885 11.6905C11.559 11.6905 9.26953 13.9892 9.26953 16.8039V23.7702C9.26953 26.5849 11.559 28.8835 14.3885 28.8835H27.6322C30.45 28.8835 32.7512 26.5849 32.7512 23.7702V16.8039C32.7512 13.9892 30.45 11.6905 27.6322 11.6905C27.5265 11.6905 27.4444 11.6319 27.3974 11.5498Z",
    fill: "#24348B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4526 11.2132L27.4527 11.2132L27.4514 11.2105C27.3974 11.0967 27.342 10.9797 27.2862 10.8617C27.0146 10.2881 26.7316 9.69028 26.5456 9.31871L26.5448 9.31721C25.9741 8.20182 24.984 7.5728 23.7714 7.56031V7.5603H23.7695L18.2395 7.56029L18.2376 7.56031C17.0242 7.57281 16.0462 8.20263 15.4759 9.31721L15.4752 9.31871C15.2683 9.73201 14.935 10.4341 14.6349 11.0663C14.593 11.1545 14.5517 11.2414 14.5116 11.3259L14.442 11.4649C14.439 11.4708 14.4364 11.4769 14.434 11.4831C14.4331 11.4857 14.4316 11.4885 14.4255 11.4921C14.418 11.4966 14.405 11.5008 14.3885 11.5008C11.4541 11.5008 9.07983 13.8845 9.07983 16.8039V23.7702C9.07983 26.6895 11.4541 29.0732 14.3885 29.0732H27.6322C30.5546 29.0732 32.9409 26.6898 32.9409 23.7702V16.8039C32.9409 13.8842 30.5546 11.5008 27.6322 11.5008C27.6158 11.5008 27.6037 11.4966 27.5938 11.4904C27.5843 11.4845 27.5744 11.475 27.5656 11.4614L27.4526 11.2132Z",
    stroke: "url(#paint1_linear)",
    strokeWidth: 0.379396,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5405 16.0536C26.5405 16.6399 27.0102 17.1091 27.5972 17.1091C28.1843 17.1091 28.6656 16.6399 28.6656 16.0536C28.6656 15.4672 28.1843 14.9863 27.5972 14.9863C27.0102 14.9863 26.5405 15.4672 26.5405 16.0536ZM24.2631 23.1371C23.4295 23.9698 22.2789 24.4858 21.0108 24.4858C19.7781 24.4858 18.6275 24.0049 17.7469 23.1371C16.8781 22.2575 16.3967 21.1082 16.3967 19.8768C16.385 18.6571 16.8663 17.5077 17.7352 16.6281C18.6157 15.7486 19.7781 15.2677 21.0108 15.2677C22.2436 15.2677 23.406 15.7486 24.2748 16.6164C25.1436 17.496 25.625 18.6571 25.625 19.8768C25.6133 21.1551 25.0967 22.3044 24.2631 23.1371ZM21.011 17.0268C20.2479 17.0268 19.5317 17.32 18.9799 17.8712C18.4398 18.4107 18.1463 19.1261 18.158 19.8649V19.8767C18.158 20.639 18.4515 21.3544 18.9916 21.8938C19.5317 22.4333 20.2479 22.7265 21.011 22.7265C22.5843 22.7265 23.8523 21.4482 23.8641 19.8767C23.8641 19.1143 23.5705 18.399 23.0305 17.8595C22.4904 17.32 21.7742 17.0268 21.011 17.0268Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5405 16.0536C26.5405 16.6399 27.0102 17.1091 27.5972 17.1091C28.1843 17.1091 28.6656 16.6399 28.6656 16.0536C28.6656 15.4672 28.1843 14.9863 27.5972 14.9863C27.0102 14.9863 26.5405 15.4672 26.5405 16.0536ZM24.2631 23.1371C23.4295 23.9698 22.2789 24.4858 21.0108 24.4858C19.7781 24.4858 18.6275 24.0049 17.7469 23.1371C16.8781 22.2575 16.3967 21.1082 16.3967 19.8768C16.385 18.6571 16.8663 17.5077 17.7352 16.6281C18.6157 15.7486 19.7781 15.2677 21.0108 15.2677C22.2436 15.2677 23.406 15.7486 24.2748 16.6164C25.1436 17.496 25.625 18.6571 25.625 19.8768C25.6133 21.1551 25.0967 22.3044 24.2631 23.1371ZM21.011 17.0268C20.2479 17.0268 19.5317 17.32 18.9799 17.8712C18.4398 18.4107 18.1463 19.1261 18.158 19.8649V19.8767C18.158 20.639 18.4515 21.3544 18.9916 21.8938C19.5317 22.4333 20.2479 22.7265 21.011 22.7265C22.5843 22.7265 23.8523 21.4482 23.8641 19.8767C23.8641 19.1143 23.5705 18.399 23.0305 17.8595C22.4904 17.32 21.7742 17.0268 21.011 17.0268Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2631 23.1371L24.3167 23.1908L24.2631 23.1371ZM17.7469 23.1371L17.6929 23.1904L17.6936 23.1911L17.7469 23.1371ZM16.3967 19.8768H16.4726L16.4726 19.876L16.3967 19.8768ZM17.7352 16.6281L17.6815 16.5745L17.6812 16.5748L17.7352 16.6281ZM24.2748 16.6164L24.3288 16.5631L24.3284 16.5627L24.2748 16.6164ZM25.625 19.8768L25.7009 19.8774V19.8768H25.625ZM18.9799 17.8712L18.9263 17.8175L18.9799 17.8712ZM18.158 19.8649H18.2339L18.2339 19.8637L18.158 19.8649ZM18.9916 21.8938L18.938 21.9475L18.9916 21.8938ZM23.8641 19.8767L23.9399 19.8772V19.8767H23.8641ZM23.0305 17.8595L23.0841 17.8058L23.0305 17.8595ZM27.5972 17.0332C27.052 17.0332 26.6164 16.598 26.6164 16.0536H26.4647C26.4647 16.6819 26.9684 17.1849 27.5972 17.1849V17.0332ZM28.5898 16.0536C28.5898 16.5969 28.1435 17.0332 27.5972 17.0332V17.1849C28.225 17.1849 28.7415 16.683 28.7415 16.0536H28.5898ZM27.5972 15.0622C28.1424 15.0622 28.5898 15.5092 28.5898 16.0536H28.7415C28.7415 15.4252 28.2261 14.9104 27.5972 14.9104V15.0622ZM26.6164 16.0536C26.6164 15.5081 27.0531 15.0622 27.5972 15.0622V14.9104C26.9673 14.9104 26.4647 15.4263 26.4647 16.0536H26.6164ZM21.0108 24.5617C22.2999 24.5617 23.4695 24.037 24.3167 23.1908L24.2094 23.0834C23.3894 23.9025 22.2579 24.4099 21.0108 24.4099V24.5617ZM17.6936 23.1911C18.5881 24.0727 19.7577 24.5617 21.0108 24.5617V24.4099C19.7984 24.4099 18.6668 23.9372 17.8002 23.083L17.6936 23.1911ZM16.3208 19.8768C16.3208 21.1286 16.8104 22.2969 17.6929 23.1904L17.8009 23.0838C16.9458 22.2181 16.4726 21.0878 16.4726 19.8768H16.3208ZM17.6812 16.5748C16.7987 17.4682 16.3089 18.6368 16.3208 19.8775L16.4726 19.876C16.461 18.6774 16.9339 17.5473 17.7891 16.6815L17.6812 16.5748ZM21.0108 15.1918C19.7579 15.1918 18.5763 15.6807 17.6815 16.5745L17.7888 16.6818C18.6552 15.8164 19.7983 15.3436 21.0108 15.3436V15.1918ZM24.3284 16.5627C23.4453 15.6806 22.2637 15.1918 21.0108 15.1918V15.3436C22.2236 15.3436 23.3666 15.8165 24.2212 16.6701L24.3284 16.5627ZM25.7009 19.8768C25.7009 18.6368 25.2114 17.4566 24.3288 16.5631L24.2208 16.6697C25.0758 17.5354 25.5491 18.6774 25.5491 19.8768H25.7009ZM24.3167 23.1908C25.164 22.3444 25.6889 21.1762 25.7009 19.8774L25.5491 19.8761C25.5376 21.1339 25.0294 22.2644 24.2094 23.0834L24.3167 23.1908ZM19.0335 17.9249C19.5711 17.3879 20.268 17.1027 21.011 17.1027V16.9509C20.2278 16.9509 19.4923 17.2521 18.9263 17.8175L19.0335 17.9249ZM18.2339 19.8637C18.2225 19.146 18.5075 18.4503 19.0335 17.9249L18.9263 17.8175C18.3721 18.3711 18.0701 19.1061 18.0821 19.8661L18.2339 19.8637ZM18.2339 19.8767V19.8649H18.0821V19.8767H18.2339ZM19.0452 21.8402C18.5195 21.315 18.2339 20.619 18.2339 19.8767H18.0821C18.0821 20.6589 18.3835 21.3937 18.938 21.9475L19.0452 21.8402ZM21.011 22.6506C20.2678 22.6506 19.5709 22.3653 19.0452 21.8402L18.938 21.9475C19.4925 22.5014 20.228 22.8024 21.011 22.8024V22.6506ZM23.7882 19.8761C23.7768 21.4066 22.542 22.6506 21.011 22.6506V22.8024C22.6267 22.8024 23.9279 21.4898 23.9399 19.8772L23.7882 19.8761ZM22.9768 17.9132C23.5025 18.4383 23.7882 19.1343 23.7882 19.8767H23.9399C23.9399 19.0944 23.6386 18.3596 23.0841 17.8058L22.9768 17.9132ZM21.011 17.1027C21.7543 17.1027 22.4511 17.388 22.9768 17.9132L23.0841 17.8058C22.5296 17.2519 21.7941 16.9509 21.011 16.9509V17.1027Z",
    fill: "url(#paint3_linear)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-1)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5621 2H28.0118C27.9316 2 27.8601 2.0504 27.8331 2.1259L26.531 5.77193C26.4868 5.89547 26.5784 6.02543 26.7096 6.02543H28.3261C28.4577 6.02543 28.5493 6.15624 28.5044 6.27996L27.7648 8.31365C27.6942 8.50779 27.9408 8.65893 28.0818 8.50792L31.1744 5.19444C31.2875 5.07318 31.2016 4.87531 31.0357 4.87531H29.507C29.3596 4.87531 29.2685 4.71445 29.3444 4.58801L30.7248 2.2873C30.8006 2.16086 30.7096 2 30.5621 2Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0.548316,
    y: 0.718238,
    width: 27.6703,
    height: 25.8667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.22487,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b",
    x: 3.19871,
    y: 1.68016,
    width: 35.6224,
    height: 33.2742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.84547
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd",
    x: 10.7055,
    y: 9.29539,
    width: 23.651,
    height: 20.8813,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.84547
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.89698,
    dy: 1.89698
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89698
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.203922 0 0 0 0 0.545098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2,
    y1: 8.46875,
    x2: 25.2745,
    y2: 9.67948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24348B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63A8EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 13.0074,
    y1: 10.2121,
    x2: 31.7056,
    y2: 29.9221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 27.7958,
    y1: 16.7017,
    x2: 14.1388,
    y2: 17.2768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 28.1399,
    y1: 19.937,
    x2: 16.2254,
    y2: 20.5781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 26.4404,
    y1: 2,
    x2: 33.0864,
    y2: 4.11437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24348B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63A8EB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.39886745.svg";
export { ForwardRef as ReactComponent };